<template>
  <Layout>
    <div class="header__bg">
      <BaseBannerTitle title="專人聯繫" sub-title="Contact" />
    </div>
    <section :class="$style.sectionContact">
      <div class="container">
        <div class="row sectionContact__list">
          <div class="col-lg-5 col-12 sectionContact__item--left text-lg-left text-center">
            <div class="sectionContact__title">
              <img class="bg" src="@assets/images/contact/paw-1.svg" alt="" />
              <BaseSectionTitle title="專人聯繫" class="isStyleDecoration mx-lg-0 mx-auto title islgCenter" />
            </div>
            <p class="sectionContact__content color-text-2 mb-0">
              經營寵物服務的所有管理工作是否有些混亂？<br />
              請留下您的聯繫方式，我們將儘速安排專人為您服務！<br />
              簡化寵物服務的管理，提高管理工作效率，更能安心為您的客戶提供更佳的服務！<br />
              如有任何疑問，歡迎隨時與我們聯繫，我們在這裡做您的支援。<br />
            </p>
            <ul class="list-unstyled sectionContact__contactList">
              <li class="sectionContact__contactItem font-Inter ls-0">
                <span class="color-primary icon align-middle">
                  <i class="icomoon icon-mail"></i>
                </span>
                service@ipetbooking.com
              </li>
              <li class="sectionContact__contactItem font-Inter ls-0">
                <span class="color-primary icon align-middle">
                  <i class="icomoon icon-phone"></i>
                </span>
                (02)2531-6628
              </li>
              <li class="sectionContact__contactItem font-Inter ls-0">
                <span class="color-primary icon align-middle">
                  <i class="icomoon icon-fb"></i>
                </span>
                iPetBooking i寵訂
              </li>
            </ul>
          </div>
          <div class="col-lg-7 col-12 sectionContact__item--right">
            <ValidationObserver v-slot="{ invalid, handleSubmit }">
              <el-form ref="form" :model="submitData" class="isStyleBase" label-position="top" @submit.prevent.native="handleSubmit(onSubmit)">
                <ValidationProvider v-slot="{ errors }" rules="require" name="姓名">
                  <el-form-item class="" prop="name" :error="errors[0]">
                    <el-input v-model="submitData.name" placeholder="你的大名"></el-input>
                  </el-form-item>
                </ValidationProvider>
                <ValidationProvider v-slot="{ errors }" rules="require|email" name="電子郵件">
                  <el-form-item class="" prop="email" :error="errors[0]">
                    <el-input v-model="submitData.email" placeholder="電子郵件地址"></el-input>
                  </el-form-item>
                </ValidationProvider>
                <ValidationProvider v-slot="{ errors }" rules="require|phone" name="電話">
                  <el-form-item class="" prop="phone" :error="errors[0]">
                    <el-input v-model="submitData.phone" placeholder="聯絡電話"></el-input>
                  </el-form-item>
                </ValidationProvider>
                <ValidationProvider v-slot="{ errors }" rules="require" name="留言訊息">
                  <el-form-item class="" prop="message" :error="errors[0]">
                    <el-input v-model="submitData.message" type="textarea" placeholder="留言訊息" :rows="7"></el-input>
                  </el-form-item>
                </ValidationProvider>
                <template v-if="isSend">
                  <BaseButton :loading="loadingSendContact" type="button" class="isStylePrimary submit">
                    已成功送出訊息
                  </BaseButton>
                </template>
                <template v-else>
                  <BaseButton :loading="loadingSendContact" type="submit" class="isStylePrimary submit">
                    送出訊息
                  </BaseButton>
                </template>
              </el-form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </section>
    <GoogleReCaptchaV3 id="contact_us_captcha" ref="captcha" v-model="submitData.g_recaptcha_response" :site-key="googleReCaptcha.siteKey" :inline="false" action="contact_us"></GoogleReCaptchaV3>
    <!-- <pre>submitData: {{ submitData }}</pre> -->
  </Layout>
</template>

<script>
import Layout from '@layout/main'
import GoogleReCaptchaV3 from '@components/GoogleReCaptchaV3'
import { messageSuccess } from '@utils/message'

export default {
  page() {
    return {
      title: '專人聯繫',
    }
  },
  components: {
    Layout,
    GoogleReCaptchaV3,
  },
  data() {
    return {
      submitData: {
        name: '',
        email: '',
        phone: '',
        message: '',
        g_recaptcha_response: '',
      },
      googleReCaptcha: {
        siteKey: '6Lf2LlcbAAAAANb1gKClQNEbRRAjU5RfIJ3sIm3v',
      },
      // loadingGetCode: false,
      loadingSendContact: false,
      isSend: false,
    }
  },
  computed: {
    // phoneNumberValid() {
    //   const value = this.submitData.phoneNumber;
    //   const phoneRegExp = new RegExp(/^09/);
    //   const numberRegExp = new RegExp(/^[0-9]*$/);
    //   return phoneRegExp.test(value)
    //     && numberRegExp.test(value)
    //     && String(value).length === 10
    // },
  },
  methods: {
    onSubmit() {
      this.tryToSendContact()
    },
    async tryToSendContact() {
      this.loadingSendContact = true
      await this.$store
        .dispatch('send/sendContact', {
          ...this.submitData,
        })
        .then((response) => {
          this.$notify({
            title: '已送出訊息',
            message: '您的訊息已成功送出，我們將盡快回覆您',
            iconClass: 'successIcon',
            customClass: 'isStyleBase',
            offset: 100,
          })
          this.isSend = true
        })
        .finally(() => {
          this.loadingSendContact = false
        })
    },
  },
}
</script>
<style lang="scss" module>
.sectionContact {
  position: relative;
  &:before {
    content: url('@assets/images/contact/paw2.svg');
    position: absolute;
    right: 0;
    bottom: -70px;
    @include max-lg {
      content: '';
    }
  }
  @include max-lg {
    margin-top: 190px;
  }
  @include max-md {
    margin-top: 140px;
  }
  :global {
    .sectionContact {
      &__title {
        position: relative;
        width: 480px;
        max-width: 100%;
        .bg {
          position: absolute;
          left: -85px;
          top: -66px;
        }
        @include max-lg {
          margin: 0 auto;
          .bg {
            // position: relative;
            left: 2%;
            top: -56px;
            max-width: 133px;
          }
        }
        @include max-md {
          .bg {
            left: -22px;
          }
        }
      }
      &__item {
        &--left {
          @include max-lg {
            margin-bottom: 40px;
          }
        }
        &--right {
          @include max-lg {
            margin-bottom: 80px;
          }
        }
      }
      &__content {
        // color: color
        margin-top: -20px;
      }
      &__contactList {
        margin-top: 3rem;
      }
      &__contactItem {
        &:not(:first-child) {
          margin-top: 1rem;
        }
      }
    }
    .submit {
      margin-top: 60px;
      @include max-lg {
        width: 100%;
      }
    }
  }
}
</style>
